import { StationIcon } from '@app/components/stations/StationIcon';
import { GroupIcon } from '@app/components/users/GroupIcon';
import { Grid } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { DashboardItem } from '../DashboardItem';
import { AdminSection } from '../Section';

interface Props {
  readonly stationsCount: number;
  readonly usersCount: number | null;
}

export function CoreAdministrationSection(p: Props) {
  const { stationsCount, usersCount } = p;

  return (
    <AdminSection
      title={
        <FormattedMessage
          id="admin.dashboard.coreAdministrationTitle"
          defaultMessage="Administración core"
        />
      }
    >
      <Grid container spacing={2}>
        <DashboardItem
          icon={<StationIcon />}
          title={<FormattedMessage id="admin.dashboard.stationsTitle" defaultMessage="Emisoras" />}
          content={
            <FormattedMessage
              id="admin.dashboard.stationsBody"
              defaultMessage="Hay {countBold} {count, plural, one {emisora registrada} other {emisoras registradas} }"
              values={{
                count: stationsCount,
                countBold: <strong>{stationsCount}</strong>,
              }}
            />
          }
          actions={[
            {
              to: '/admin/stations',
              text: (
                <FormattedMessage
                  id="admin.dashboard.stationsBtnText"
                  defaultMessage="Administrar"
                />
              ),
              dataCy: 'manage-stations',
            },
          ]}
        />

        <DashboardItem
          icon={<GroupIcon />}
          title={
            <FormattedMessage id="admin.dashboard.usersTitle" defaultMessage="Usuarios y grupos" />
          }
          content={
            <FormattedMessage
              id="admin.dashboard.usersBody"
              defaultMessage="Hay {countBold} {count, plural, one {usuario registrado} other {usuarios registrados} }"
              values={{
                count: usersCount,
                countBold: <strong>{usersCount}</strong>,
              }}
            />
          }
          actions={[
            {
              to: '/admin/users',
              text: (
                <FormattedMessage
                  id="admin.dashboard.usersBtnText"
                  defaultMessage="Administrar usuarios"
                />
              ),
              className: 'btn-manage-users',
              dataCy: 'manage-users',
            },
            {
              to: '/admin/groups',
              text: (
                <FormattedMessage
                  id="admin.dashboard.groupsBtnText"
                  defaultMessage="Administrar grupos"
                />
              ),
              dataCy: 'manage-groups',
            },
          ]}
        />
      </Grid>
    </AdminSection>
  );
}
